module.exports = __webpack_public_path__ + "static/img/10001 (2).ad51103.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10001 (2).webp
// module id = qhY1
// module chunks = 14